import { useCallback, useState } from 'react';
import { fileUpload } from '../common/utils';

export const UPLOAD_FAILED_PROGRESS = -1;

const useS3FileUpload = () => {
  const [progress, setProgress] = useState({});
  const [isUploading, setIsUploading] = useState(false);

  const resetProgress = useCallback(() => setProgress({}), []);

  const uploadFile = useCallback(async (file, getSignedPutUrl) => {
    const uid = file?.uid || file?.name;
    setIsUploading(true);
    setProgress((prevProgress) => ({ ...prevProgress, [uid]: 0 }));
    try {
      const signedData = await getSignedPutUrl(file?.name);
      if (!signedData?.signedUrl) {
        throw new Error('Could not prepare the upload. Please try again.');
      }
      try {
        await fileUpload(signedData?.signedUrl, file, (percent) =>
          setProgress((prevProgress) => ({ ...prevProgress, [uid]: percent })),
        );
      } catch (error) {
        throw new Error(`${file?.name} upload failed. Please try again.`);
      }
      setProgress((prevProgress) => ({ ...prevProgress, [uid]: 100 }));
      return signedData;
    } catch (error) {
      setProgress((prevProgress) => ({
        ...prevProgress,
        [uid]: UPLOAD_FAILED_PROGRESS,
      }));
      throw error;
    } finally {
      setIsUploading(false);
    }
  }, []);

  return { uploadFile, isUploading, progress, resetProgress };
};

export default useS3FileUpload;
